<template>
  <v-app id="login">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md3>
            <LoginForm></LoginForm>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>

  import LoginForm from '@/components/LoginForm.vue'

  export default {
    components: { LoginForm }
  }

</script>

<style>
  #login { background: rgb(0, 24, 47) }
</style>
